import { blackberry, grape, greyStroke, squidInk, white } from 'lib/css/colors';

/**
 * Custom styles for react-select components to match the purple/grape theme.
 * Use this for consistent styling across all Select components.
 */
export const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? grape : greyStroke,
    boxShadow: state.isFocused ? `0 0 0 1px ${grape}` : 'none',
    borderRadius: 8,
    '&:hover': {
      borderColor: grape,
    },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? blackberry : state.isFocused ? `${grape}15` : white,
    color: state.isSelected ? white : squidInk,
    '&:active': {
      backgroundColor: grape,
    },
  }),
};
